export default {
  priceAndConsiderations: {
    chapter: '5',
    component: 'helmi-section',
    props: {
      label: 'Myyntihinta ja myyntinäkökohdat',
    },
    children: {
      debtFreeSellingPrice: {
        chapter: '5.1',
        component: 'helmi-text-field',
        container: {
          cols: 12,
          md: 4,
        },
        props: {
          hint: 'Osapuolten sopima kohteen myyntihinta',
          label: 'Myyntihinta (tai tarjouskaupan lähtöhinta)',
          suffix: '€',
          type: 'number',
        },
        value: null,
      },

      estimatedActualPurchasePrice: {
        chapter: '5.2',
        component: 'helmi-text-field',
        container: {
          cols: 12,
          md: 4,
        },
        props: {
          hint: 'Välitysliikkeen tilastoihin perustuva arvio tai käsitys toteutuvasta myyntihinnasta',
          label: 'Arvio toteutuvasta myyntihinnasta',
          type: 'text',
        },
        value: null,
      },

      targePriceBid: {
        chapter: '5.3',
        component: 'helmi-text-field',
        container: {
          cols: 12,
          md: 4,
        },
        props: {
          label: 'Tarjouskaupan tavoitehinta',
          suffix: '€',
          type: 'number',
        },
        value: null,
      },

      estimatedSalesPeriod: {
        chapter: '5.4',
        component: 'helmi-text-field',
        container: {
          cols: 12,
        },
        props: {
          hint: 'Välitysliikkeen kauppahintatilastoihin perustuva arvio keskimääräisestä myyntiajasta',
          label: 'Keskimääräinen toteutunut myyntiaika',
          type: 'text',
        },
        value: null,
      },

      sellingPointsAndWeaknesses: {
        chapter: '5.5',
        component: 'helmi-textarea',
        container: {
          cols: 12,
          md: 12,
        },
        props: {
          label: 'Välitysliikkeen tiedossa olevat hintaan, sen arviointiin ja myyntiaikaan vaikuttavat erityiset tekijät',
          type: 'text',
        },
        value: null,
      },

      paymentTerm: {
        chapter: '5.6',
        component: 'helmi-radiogroup',
        container: {
          cols: 12,
        },
        props: {
          label: 'Maksuehto',
        },
        options: ['Käteinen', 'Muu maksuehto'],
        value: 'Käteinen',
      },

      additionalInfo: {
        chapter: '5.7',
        component: 'helmi-textarea',
        condition: {
          item: 'paymentTerm',
          type: '=',
          value: 'Muu maksuehto',
        },
        container: {
          cols: 12,
        },
        props: {
          label: 'Lisätietoja maksuehdosta',
        },
        value: null,
      },
    },
  },

  rent: {
    chapter: '6',
    component: 'helmi-section',
    props: {
      label: 'Kohteen vapautuminen / vuokralainen',
    },
    children: {

      releaseDate: {
        chapter: '6.1',
        component: 'helmi-text-field',
        container: {
          cols: 12,
        },
        props: {
          label: 'Kohteen vapautuminen',
          type: 'text',
        },
        value: null,
      },

      rented: {
        chapter: '6.2',
        component: 'helmi-radiogroup',
        container: {
          cols: 12,
        },
        props: {
          label: 'Kohde on vuokrattu',
        },
        options: ['Kyllä', 'Ei'],
        value: 'Ei',
      },

      rentType_1: {
        chapter: '6.2.1',
        component: 'helmi-checkbox',
        condition: {
          item: 'rented',
          type: '=',
          value: 'Kyllä',
        },
        container: {
          cols: 12,
        },
        props: {
          label: 'Kirjallinen sopimus',
        },
        value: 'Ei',
      },

      rentType_2: {
        chapter: '6.2.2',
        component: 'helmi-checkbox',
        condition: {
          item: 'rented',
          type: '=',
          value: 'Kyllä',
        },
        container: {
          cols: 12,
        },
        props: {
          label: 'Suullinen sopimus',
        },
        value: 'Ei',
      },

      rentType_3: {
        chapter: '6.2.3',
        component: 'helmi-checkbox',
        condition: {
          item: 'rented',
          type: '=',
          value: 'Kyllä',
        },
        container: {
          cols: 12,
        },
        props: {
          label: 'Määräaikainen sopimus',
        },
        value: 'Ei',
      },

      rentType_4: {
        chapter: '6.2.4',
        component: 'helmi-checkbox',
        condition: {
          item: 'rented',
          type: '=',
          value: 'Kyllä',
        },
        container: {
          cols: 12,
        },
        props: {
          label: 'Toistaiseksi voimassaoleva sopimus',
        },
        value: 'Ei',
      },

      rentAmount: {
        chapter: '6.2.5',
        component: 'helmi-text-field',
        condition: {
          item: 'rented',
          type: '=',
          value: 'Kyllä',
        },
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Vuokra',
          type: 'text',
        },
        value: null,
      },

      occupantName: {
        chapter: '6.2.6',
        component: 'helmi-text-field',
        condition: {
          item: 'rented',
          type: '=',
          value: 'Kyllä',
        },
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Asukkaan nimi',
          type: 'text',
        },
        value: null,
      },

      occupantPhone: {
        chapter: '6.2.7',
        component: 'helmi-text-field',
        condition: {
          item: 'rented',
          type: '=',
          value: 'Kyllä',
        },
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Asukkaan puhelinnumero',
          type: 'text',
        },
        value: null,
      },

      occupantEmail: {
        chapter: '6.2.8',
        component: 'helmi-text-field',
        condition: {
          item: 'rented',
          type: '=',
          value: 'Kyllä',
        },
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Asukkaan sähköpostiosoite',
          type: 'text',
        },
        value: null,
      },

      additionalInfoLease: {
        chapter: '6.2.9',
        component: 'helmi-textarea',
        condition: {
          item: 'rented',
          type: '=',
          value: 'Kyllä',
        },
        container: {
          cols: 12,
        },
        props: {
          label: 'Lisätietoja vuokrasopimuksesta',
        },
        value: null,
      },
    },
  },

  periodOfValidity: {
    chapter: '7',
    component: 'helmi-section',
    props: {
      label: 'Toimeksiannon voimassaoloaika',
    },
    children: {
      typeOfAgreement: {
        chapter: '7.1',
        component: 'helmi-radiogroup',
        container: {
          cols: 12,
        },
        props: {
          label: 'Toimeksiannon voimassaolo',
        },
        options: [
          'Määräaikainen',
          'Toistaiseksi voimassa oleva',
        ],
        value: 'Määräaikainen',
      },

      timeLimitedFrom: {
        chapter: '7.1.1',
        component: 'helmi-date-picker',
        condition: {
          item: 'typeOfAgreement',
          type: '=',
          value: 'Määräaikainen',
        },
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Alkamispäivä (Määräaikainen)',
          type: 'text',
        },
        value: null,
      },

      untilFurtherNoticeFrom: {
        chapter: '7.1.3',
        component: 'helmi-date-picker',
        condition: {
          item: 'typeOfAgreement',
          type: '=',
          value: 'Toistaiseksi voimassa oleva',
        },
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Alkamispäivä (Toistaiseksi)',
          type: 'text',
        },
        value: null,
      },

      timeLimitedTo: {
        chapter: '7.1.2',
        component: 'helmi-date-picker',
        condition: {
          item: 'typeOfAgreement',
          type: '=',
          value: 'Määräaikainen',
        },
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Lopetuspäivä (Määräaikainen)',
          type: 'text',
        },
        value: null,
      },

      untilFurtherNoticePeriod: {
        chapter: '7.1.4',
        component: 'helmi-text-field',
        condition: {
          item: 'typeOfAgreement',
          type: '=',
          value: 'Toistaiseksi voimassa oleva',
        },
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Jakson pituus (Toistaiseksi)',
          type: 'text',
        },
        value: null,
      },

      untilFurtherNoticeTitle: {
        chapter: '7.1.5',
        classes: 'text-subtitle-2',
        component: 'helmi-title',
        condition: {
          item: 'typeOfAgreement',
          type: '=',
          value: 'Toistaiseksi voimassa oleva',
        },
        props: {
          label: 'Toistaiseksi voimassa oleva toimeksianto on voimassa toistaiseksi valitusta ajankohdasta alkaen kohdassa 7.1.4 valitun pituisissa jaksoissa niin, että se voidaan kirjallisesti irtisanoa viimeistään kymmenen (10) päivää ennen seuraavan sopimuskauden alkamista. Toimeksiannon voimassaolo päättyy kuitenkin aina neljän kuukauden kuluttua voimassaolon alkamisesta, ellei sitä kirjallisesti jatketa välityslain edellyttämällä tavalla.',
        },
      },
    },
  },

  brokerageAndPayment: {
    chapter: '8',
    component: 'helmi-section',
    props: {
      label: 'Välityspalkkion suuruus ja suoritus',
    },
    children: {
      percentage: {
        chapter: '8.1',
        component: 'helmi-text-field',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Välityspalkkioprosentti sis. ALV',
          suffix: '%',
          type: 'number',
        },
        value: null,
      },

      fixedFee: {
        chapter: '8.2',
        component: 'helmi-text-field',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Kiinteä palkkio sis. ALV',
          suffix: '€',
          type: 'number',
        },
        value: null,
      },

      minimumFee: {
        chapter: '8.3',
        component: 'helmi-text-field',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Vähimmäispalkkio sis. ALV',
          suffix: '€',
          type: 'number',
        },
        value: null,
      },

      // additionalFeeBasis: {
      //   chapter: '8.4',
      //   component: 'helmi-text-field',
      //   container: {
      //     cols: 12,
      //     md: 6,
      //   },
      //   props: {
      //     label: 'Muu palkkioperuste',
      //     type: 'text',
      //   },
      //   value: null,
      // },

      photography: {
        chapter: '8.4',
        component: 'helmi-text-field',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Valokuvaus sis. ALV',
          suffix: '€',
          type: 'number',
        },
        value: null,
      },

      marketing: {
        chapter: '8.5',
        component: 'helmi-text-field',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Markkinointikulut sis. ALV',
          type: 'number',
          suffix: '€',
        },
        value: null,
      },

      documents: {
        chapter: '8.6',
        component: 'helmi-text-field',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Asiakirjakulut sis. ALV',
          type: 'number',
          suffix: '€',
        },
        value: null,
      },

      additionalFees: {
        chapter: '8.7',
        classes: 'text-subtitle-2',
        component: 'helmi-title',
        props: {
          label: 'Markkinointikustannuksista ja asiakirjojen hankkimisesta sovitun välityspalkkion lisäksi perittävät summat',
        },
      },

      otherExpenses: {
        chapter: '8.7.1',
        component: 'helmi-text-field',
        container: {
          cols: 12,
        },
        props: {
          label: 'Muut kustannukset',
          type: 'text',
        },
        value: null,
      },

      fallBackFees: {
        chapter: '8.8',
        classes: 'text-subtitle-2',
        component: 'helmi-title',
        props: {
          label: 'Jos toimeksiantaja ei ole velvollinen maksamaan välityspalkkiota, toimeksiantaja suorittaa välitysliikkeelle kuitenkin seuraavat korvaukset',
        },
      },

      marketingAndAqcuisitionFee: {
        chapter: '8.8.1',
        component: 'helmi-text-field',
        container: {
          cols: 12,
        },
        props: {
          label: 'Markkinointikustannukset ja asiakirjojen hankkimiskulu',
          type: 'text',
        },
        value: null,
      },
    },
  },

  notificationsFromTheParties: {
    chapter: '9',
    component: 'helmi-section',
    props: {
      label: 'Osapuolten ilmoitukset',
    },
    children: {
      permanentHousing: {
        chapter: '9.1',
        component: 'helmi-radiogroup',
        container: {
          cols: 12,
        },
        props: {
          label: 'Toimeksiantaja vakuuttaa, että välitettävä omaisuus on tarkoitettu käytettäväksi hänen ja hänen aviopuolisonsa tai rekisteröidyssä parisuhteesta annetun lain (950/2001) tarkoittaman puolisonsa yhteisenä kotina.',
        },
        options: ['Kyllä', 'Ei'],
        value: null,
      },

      permanentResidence: {
        chapter: '9.2',
        classes: 'text-subtitle-2',
        component: 'helmi-title',
        props: {
          label: 'Toimeksiantaja on omistusaikanaan käyttänyt vähintään puolta huoneistosta yhtäjaksoisesti vakituisena asuntonaan. Jollei tällaista yhtäjaksoista asumisaikaa jokaisen osaomistajan osalta omistusaikana ole vähintään kahta vuotta, myynnistä voi syntyä verotettavaa luovutusvoittoa.',
        },
      },

      usedAsPermanentResidence1: {
        chapter: '9.2.1',
        component: 'helmi-text-field',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Toimeksiantaja 1',
          type: 'text',
        },
        value: null,
      },

      usedAsPermanentResidence2: {
        chapter: '9.2.2',
        component: 'helmi-text-field',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Toimeksiantaja 2',
          type: 'text',
        },
        value: null,
      },

      acquisition: {
        chapter: '9.3',
        component: 'helmi-select',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Saanto',
        },
        options: [
          'Kauppa',
          'Perintö',
          'Lahja',
          'Testamentti',
          'Vaihto',
          'Ositus',
        ],
        value: null,
      },

      acquisitionYear: {
        chapter: '9.4',
        component: 'helmi-text-field',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Saantovuosi',
          type: 'text',
        },
        value: null,
      },

      legalPartition: {
        chapter: '9.5',
        component: 'helmi-radiogroup',
        container: {
          cols: 12,
        },
        options: ['Kyllä', 'Ei'],
        props: {
          label: 'Mikäli toimeksiantajan avioliitto tai rekisteröity parisuhde on purkautunut kuoleman, avioeron tai rekisteröidyn parisuhteen purkamisen johdosta, toimeksiantaja ilmoittaa, että ositus tai omaisuuden erottelu on lainvoimainen',
        },
      },

      clientHasBeenInformedOfTaxes: {
        chapter: '9.5.1',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
        },
        props: {
          label: 'Toimeksiantajalle on kerrottu osituksen tekemisen vaikutuksista luovutusvoiton veroseuraamuksiin.',
        },
        value: 'Ei',
      },

      capitalGainsTax: {
        chapter: '9.6',
        component: 'helmi-radiogroup',
        container: {
          cols: 12,
        },
        options: ['Kyllä', 'Ei'],
        props: {
          label: 'Tässä sopimuksessa annettujen tietojen perusteella myynnistä menee luovutusvoittoveroa',
        },
      },

      directClientToTaxAdministration: {
        chapter: '9.7',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
        },
        props: {
          label: 'Veroseuraamuksia ei ole ollut mahdollista selvittää saatujen tietojen perusteella tai asia on oikeudellisesti tulkinnanvarainen tai vaikea, joten toimeksiantaja ohjataan kääntymään verohallinnon puoleen veroseuraamusten selvittämiseksi.',
        },
        value: 'Ei',
      },
    },
  },

  additionalTerms: {
    chapter: '10',
    component: 'helmi-section',
    props: {
      label: 'Muut ehdot',
    },
    children: {
      responsibility_1: {
        chapter: '10.1',
        classes: 'text-subtitle-2',
        hide: true,
        component: 'helmi-title',
        props: {
          label: 'Toimeksiantajan tiedonantovelvollisuus',
          hint: 'Toimeksiantaja on tietoinen siitä, että laki velvoittaa hänet antamaan tiedon kaikista tiedossaan olevista ja sopimuksen laatimisen jälkeen tietoonsa tulleista seikoista, joiden voidaan olettaa vaikuttavan ostajan ostopäätökseen. Toimeksiantajan on kerrottava erityisesti esimerkiksi rakennusten kuntoon liittyvät seikat ja mahdolliset virheet.',
        },
      },
      responsibility_2: {
        chapter: '10.2',
        classes: 'text-subtitle-2',
        hide: true,
        component: 'helmi-title',
        props: {
          label: 'Välitysliikkeen tiedonsaanti ',
          hint: 'Välitysliikkeellä on kiinteistöjen ja vuokrahuoneistojen välityksestä annetun lain mukainen selonottovelvollisuus. Toimeksiantaja valtuuttaa välitysliikkeen pyytämään ja saamaan tähän toimeksiantosopimukseen liittyen pantinhaltijalta tiedot kaikista pantti- ja haltijavelkakirjoihin liittyvistä sitoumuksista ja niiden määristä, sekä kirjallisen ilmoituksen siitä, millä kauppahinnalla ne voidaan luovuttaa ostajalle. Toimeksiantaja valtuuttaa välitysliikkeen hankkimaan myös kaikki muut kaupanteossa tarvittavat, lain edellyttämät asiakirjat sekä tiedot myyntikohteesta (esim. maksuunpantu ja suorittamatta oleva kiinteistövero, sekä muut kohteeseen kohdistuvat maksut, kuten sähkö-, vesi-, lämpö- ja jätehoitomaksut ja liittymämaksut.)',
        },
      },
      responsibility_3: {
        chapter: '10.3',
        classes: 'text-subtitle-2',
        hide: true,
        component: 'helmi-title',
        props: {
          label: 'Erimielisyyksien ratkaiseminen',
          hint: 'Jos sopimusta koskevaa erimielisyyttä ei saada ratkaistuksi osapuolten välisillä neuvotteluilla, sopimuksen osapuoli voi saattaa asian kuluttajariitalautakunnan (www.kuluttajariita.fi) ratkaistavaksi. Ennen asian viemistä kuluttajariitalautakunnan käsittelyyn osapuolen tulee olla yhteydessä maistraattien kuluttajaneuvontaan (www.kuluttajaneuvonta.fi). Tätä sopimusta koskeva kanne on käsiteltävä toimeksiantajan Suomessa olevan asuinpaikan käräjäoikeudessa. Jos toimeksiantajan asuinpaikka on ulkomailla, oikeuspaikkana on kiinteistön sijaintipaikan käräjäoikeus. Toimeksiantajan suostumuksella kanne voidaan käsitellä välitysliikkeen kotipaikan käräjäoikeudessa.',
        },
      },
      inOfficeCommitment: {
        chapter: '10.4',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
        },
        props: {
          label: 'Toimeksiantaja on sitoutunut toimeksiantosopimuksen ehtoihin vasta välitysliikkeen toimitiloissa (ei kotimyyntitilanne).',
        },
        value: 'Ei',
      },

      outOfOfficeCommitment: {
        chapter: '10.5',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
        },
        props: {
          label: 'Toimeksiantaja on sitoutunut toimeksiantosopimuksen ehtoihin muualla kuin välitysliikkeen toimitiloissa. Tällöin kysymys on kotimyynnistä.',
        },
        value: 'Ei',
      },

      clientHasRecievedCancellationFormAndInstructions: {
        chapter: '10.6',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
        },
        props: {
          label: 'Toimeksiantaja kuittaa vastaanottaneensa erillisen peruuttamislomakkeen ja peruuttamisohjeen.',
        },
        value: 'Kyllä',
      },

      startBeforeCancellationTimeExpires: {
        chapter: '10.7',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
        },
        props: {
          label: 'Toimeksiantaja pyytää, että välitysliike aloittaa toimeksiannon suorittamisen ennen kuin peruuttamisaika on päättynyt.',
        },
        value: 'Kyllä',
      },

      asuntojenHintatiedotAcceptance: {
        chapter: '10.8',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
        },
        props: {
          label: 'Annan suostumukseni sille, että toteutuneen kaupan tiedot julkistetaan ympäristöministeriön asuntojen.hintatiedot.fi -palvelussa',
        },
        value: 'Ei',
      },

      otherTerms: {
        chapter: '10.9',
        component: 'helmi-text-field',
        container: {
          cols: 12,
        },
        props: {
          label: 'Muut ehdot',
          type: 'text',
        },
        value: null,
      },
    },
  },

  privacy: {
    chapter: '11',
    component: 'helmi-section',
    props: {
      label: 'Tietosuoja',
    },
    children: {
      privacyClause: {
        chapter: '11.1',
        component: 'helmi-title',
        hide: true,
        container: {
          cols: 12,
        },
        props: {
          hint: 'Asiakas on tietoinen siitä, että tämän lomakkeen allekirjoittajan tietoja tallennetaan välitysliikkeen toimeksiantopäiväkirjaan ja asiakasrekisteriin kiinteistönvälitysliikkeistä ja vuokrahuoneiston välitysliikkeistä annetun lain sekä rahanpesun ja terrorismin rahoittamisen estämisestä annetun lain määräysten mukaisesti. Lisäksi henkilötietoja käytetään tietosuojaselosteessa tarkemmin kuvatun mukaisesti markkinointitarkoituksia ja liiketoiminnan kehittämistä varten',
        },
      },

      privacyPolicyAvailability: {
        chapter: '11.1',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
        },
        props: {
          label: 'Asiakasta on ohjattu tutustumaan etukäteen tietosuojaselosteeseen.',
        },
        value: 'Kyllä',
      },

      dataHandlingAgreement: {
        chapter: '11.2',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
        },
        props: {
          label: 'Kaupan tietoja luovutetaan Kiinteistönvälitysalan Keskusliitto (KVKL) ry:lle, jossa tiedot tallennetaan KVKL:n hintaseurantapalveluun (HSP), jonka tietosuojaseloste on saatavilla osoitteesta www.hintaseurantapalvelu.fi/tietosuoja. Lisäksi pyydämme suostumustanne alla selostettuja tarkoituksia varten. Annatte suostumuksenne lisäämällä rastin ruutuun. Teillä on oikeus peruuttaa suostumus milloin tahansa ilmoittamalla peruuttamisesta kirjallisesti tai sähköpostitse välitysliikkeelle.',
        },
        value: 'Kyllä',
      },

      marketingAgreement: {
        chapter: '11.3',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
        },
        props: {
          label: 'Annan suostumukseni siihen, että välitysliike saa lähettää minulle sähköistä suoramarkkinointia (esim. tekstiviesti, sähköposti).',
        },
        value: 'Kyllä',
      },

      identificationInformationSharingAgreement: {
        chapter: '11.4',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
        },
        props: {
          label: 'Annan suostumukseni siihen, että välitysliike lähettää minulle, kaupan toiselle osapuolelle, isännöitsijälle, asiaan osalliselle pankille ja/tai viranomaiselle sähköpostitse henkilötunnukseni sisältäviä asiakirjoja. Henkilötunnuksen jakaminen näiden tahojen kanssa on välttämätöntä tunnistamisen varmistamiseksi.',
        },
        value: 'Kyllä',
      },

      unencryptedEmailAwareness: {
        chapter: '11.5',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
        },
        props: {
          label: 'Olen tietoinen siitä, että sähköpostia ei lähetetä suojatussa yhteydessä eikä salattuna.',
        },
        value: 'Kyllä',
      },
    },
  },

  politicalInfluence: {
    chapter: '12',
    component: 'helmi-section',
    props: {
      label: 'Poliittinen vaikutusvalta',
    },
    children: {
      PEPStatus: {
        chapter: '12.1',
        component: 'helmi-radiogroup',
        container: {
          cols: 12,
        },
        props: {
          label: 'Oletko tai oletko ollut viimeisen vuoden aikana poliittisesti vaikutusvaltainen henkilö (PEP) tai sellaisen henkilön perheenjäsen tai läheinen yhtiökumppani?',
          dense: false,
        },
        options: ['Kyllä', 'Ei'],
        value: null,
      },
      PEPAdditionalInfo: {
        chapter: '12.1.1',
        component: 'helmi-textarea',
        condition: {
          item: 'PEPStatus',
          type: '=',
          value: 'Kyllä',
        },
        container: {
          cols: 12,
        },
        props: {
          label: 'Lisätietoja',
        },
        value: null,
      },
    },
  },
};
